import React from 'react';
import { useLanguage } from '../i18n/LanguageContext';

/** EN / తెలుగు / हिंदी switch — use in footer (`dark`), light panels (`light`), or the navbar (`compact`). */
const LanguageToggle = ({ className = '', variant = 'light', compact = false }) => {
  const { t, locale, setLocalePreference } = useLanguage();
  const dark = variant === 'dark';
  const wrap = dark ? 'border-white/20 bg-white/5' : 'border-gray-200 bg-gray-50/90';
  const active = 'bg-white shadow-sm text-[#14A098]';
  const idle = dark ? 'text-gray-300 hover:text-white' : 'text-gray-500 hover:text-[#0f2540]';
  const btnSize = compact ? 'px-1.5 py-1 text-[11px]' : 'px-2.5 py-1 text-[11px]';

  const labelEn = compact ? t('nav.lang_en_short', 'En') : t('nav.lang_en', 'English');
  const labelTe = compact ? t('nav.lang_te_short', 'తె') : t('nav.lang_te', 'తెలుగు');
  const labelHi = compact ? t('nav.lang_hi_short', 'हिं') : t('nav.lang_hi', 'हिंदी');

  return (
    <div className={`flex items-center gap-0.5 rounded-full p-0.5 border ${wrap} ${className}`}>
      <button
        type="button"
        onClick={() => setLocalePreference('en')}
        className={`${btnSize} font-bold rounded-full transition-colors ${locale === 'en' ? active : idle}`}
      >
        {labelEn}
      </button>
      <button
        type="button"
        onClick={() => setLocalePreference('te')}
        className={`${btnSize} font-bold rounded-full transition-colors ${locale === 'te' ? active : idle}`}
      >
        {labelTe}
      </button>
      <button
        type="button"
        onClick={() => setLocalePreference('hi')}
        className={`${btnSize} font-bold rounded-full transition-colors ${locale === 'hi' ? active : idle}`}
      >
        {labelHi}
      </button>
    </div>
  );
};

export default LanguageToggle;
